<template>
  <div
    v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('view_customer')"
    style="border: 0px solid black; width:100%;"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{ $t("search.title") }}</h3>
          </div>

          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <!-- <div class="col-sm-4 col-md-4 col-lg-4">
                <div class="input-group">
                  <span class="input-group-addon">
                    <i class="fa fa-user"></i>
                  </span>
                  <input
                    v-on:keyup.enter="onSearchCustomer"
                    type="text"
                    class="form-control"
                    :placeholder="$t('customer.customer_code')"
                    v-model="search.code"
                  />
                </div>
              </div> -->
              <!-- <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  v-on:keyup.enter="onSearchCustomer"
                  type="text"
                  class="form-control"
                  :placeholder="$t('customer.username')"
                  v-model="search.username"
                />
              </div>-->
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="input-group">
                  <span class="input-group-addon">
                    <i class="fa fa-user"></i>
                  </span>
                  <input
                    v-on:keyup.enter="onSearchCustomer"
                    type="text"
                    class="form-control"
                    :placeholder="$t('common.fullNameOrEmail')"
                    v-model="search.searchText"
                  />
                </div>
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="input-group">
                  <span class="input-group-addon">
                    <i class="fa fa-mobile"></i>
                  </span>
                  <input
                    v-on:keyup.enter="onSearchCustomer"
                    type="text"
                    class="form-control"
                    :placeholder="$t('customer.phone')"
                    v-model="search.phone"
                  />
                </div>
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  v-on:keyup.enter="onSearchCustomer"
                  type="text"
                  class="form-control"
                  :placeholder="$t('apartment.name')"
                  v-model="search.apartment_code"
                />
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="input-group">
                  <span class="input-group-addon">
                    <i class="glyphicon glyphicon-ok"></i>
                  </span>
                  <select name="" id="" class="form-control" v-model="search.isActive">
                    <option :value="null">---</option>
                    <option :value="false">
                      {{ $t('templateNotification.state.in_active') }}
                    </option>
                    <option :value="true">
                      {{ $t('templateNotification.state.active') }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <!-- <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-4 col-md-4 col-lg-4">
                <div class="input-group">
                  <span class="input-group-addon">
                    <i class="fa fa-envelope"></i>
                  </span>
                  <input
                    v-on:keyup.enter="onSearchCustomer"
                    type="text"
                    class="form-control"
                    :placeholder="$t('customer.email')"
                    v-model="search.email"
                  />
                </div>
              </div>
            </div> -->
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-4 col-md-4 col-lg-4"></div>
              <div class="col-sm-4 col-md-4 col-lg-4"></div>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="onSearchCustomer"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("search.search_button") }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!--  -->
        <div class="box box-primary">
          <div class="box-header with-border">
            <div
              style="height:50px;box-shadow: inset 0 0px 0px rgba(10, 10, 10, 0.1);
              max-height:40px;height:60px; border:0px solid red;"
            >
              <div
                style="float:right;border:0px solid blue;text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
              >
                <lte-button
                  v-if="has_perm('create_customer') || GET_ACCOUNT_DATA.id == 1"
                  style="float:right"
                  type="btn btn-warning"
                  right_icon="fa fa-plus"
                  @click="modal_addcustomer_to_project($event)"
                  >{{ $t("user.add") }}</lte-button
                >
                <lte-button
                  v-if="has_perm('create_customer') || GET_ACCOUNT_DATA.id == 1"
                  style="float:right"
                  type="btn btn-primary"
                  right_icon="fa fa-plus"
                  @click="callback($event)"
                  >{{ $t("user.createnew") }}</lte-button>
                <lte-button
                  v-if="has_perm('export_customer') || GET_ACCOUNT_DATA.id == 1"
                  style="float:right"
                  type="btn btn-success"
                  right_icon="fa fa-download"
                  @click="onExport($event)"
                  >{{ $t("customer.export") }}</lte-button>
                <lte-button
                  v-if="has_perm('import_customer') || GET_ACCOUNT_DATA.id == 1"
                  style="float:right"
                  type="btn btn-success"
                  right_icon="fa fa-plus"
                  @click="importExcel($event)"
                  >{{ $t("customer.importExcel") }}</lte-button>
              </div>
              <select-option-check
                :item="columnsCustomer"
                class="dropdown-trigger"
                data-icon="eye"
                @callbackData="onColumnSelect"
              ></select-option-check>
            </div>
          </div>
          <div class="box-body">
            <div class="" style="display: flex; padding: 0 15px">
              <span 
                v-for="(item, index) in customerTypeList" 
                :key="item+index" 
                :class="`${index !== customerTypeList.length-1 ? 'customer-type-class border-right': 'customer-type-class'}`"
                @click="onChangeCustomerType(item)"
              >
                <span 
                  :class="item.value === customerTypeSelect ? 'customer-type-select' : ''"
                  style="white-space: nowrap; text-transform: capitalize;"
                >
                  {{$t(item.text)}} ({{item.total}})
                </span>
              </span>
            </div>
            <lte-table
              v-if="has_perm('view_customer') ||  GET_ACCOUNT_DATA.id == 1"
              :hdBackground="hdBackground"
              :data="gridCustomerDataList"
              :columns="gridColumns"
              search_filter="left-search"
              @actions="crudActions"
              :actions="
                GET_ACCOUNT_DATA.id == 1 ||
                (has_perm('update_customer') && has_perm('delete_customer'))
                  ? actions
                  : has_perm('update_customer')
                  ? [actions[0]]
                  : has_perm('delete_customer')
                  ? [actions[1]]
                  : []
              "
              :useFilter="useFilter"
              @onClickItemRow="onClickItemRow"
              :row_mouse_pointer="true"
              :boxStyle="boxStyle"
              :customColumns="customColumns"
            ></lte-table>
          </div>
        </div>
        <!--  -->

        <div
          class="box-footer clearfix"
          style="display:contents;"
          v-if="has_perm('view_customer')"
        >
          <paginator :item="paginatorItem" @onpaginate="onPagination" />
        </div>
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
        <information-modal id="modal-information-user" :customerId="entryId" />
      </row>
    </div>
    <!-- modal-confirm-customer-out-of-project -->
    <div class="modal fade" id="modal-confirm-customer-out-of-project">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <h4>
              {{ $t("common.delete_modal.content_with_param") }} email
              {{ user_deleted_email }}
              {{ $t("common.confirm_delete_email_out") }}
            </h4>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="remove_user(user_deleted_id)"
              class="btn btn-primary btn-sm pull-right"
            >
              Xác Nhận
            </button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>

    <!-- modal-get-customer-to-project -->
    <div
      class="modal fade"
      data-backdrop="static"
      id="modal-get-customer-to-project"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              {{ $t("common.add_customer_to_project") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-8 col-md-8 col-lg-8">
                <!-- EMAIL -->
                <b-form-group
                  label-size="sm"
                  label-for="input-sm"
                  :label="'Email'"
                >
                  <div class="form-group">
                    <div>
                      <input class="form-control" v-model="general_email" />
                    </div>
                  </div>
                </b-form-group>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              :class="'btn btn-primary btn-sm pull-right'"
              @click="onGetCustomerToProject"
            >
              {{ $t("common.confirm") }}
            </button>
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-warning btn-sm pull-left"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { LTEActionTypeEnum } from '@/components/LTEEnum'
import LTEButton from "@/components/LTEButton.vue";
import LTETable from "@/components/LTETable.vue";
import SelectOptionCheck from "@/components/SelectOptionCheck.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
// import JsonExcel from "vue-json-excel";
import XLSX from "xlsx";
import i18n from "../../lang";
import Paginator from "@/components/Paginator.vue";
import Loading from "vue-loading-overlay";
import InformationModal from "@/components/InformationUserModal.vue";
import utils from "@/lib/utils";

export default {
  name: "Customer",
  data() {
    return {
      buttonName: "danger",
      labelName: "Name",
      table_name: "customerlist", // for selecting viewed columns
      groupUserID: 4,
      general_email: "",
      user_deleted_id: null,
      user_deleted_email: "",
      gridCustomerDataList: [],
      useFilter: false,
      boxStyle: false,
      gridColumns: [
        { text: "common.nonumber", isHidden: true },
        { text: "customer.customer_code", isHidden: true, wrapText: 'nowrap' },
        // { text: "customer.username", isHidden: true },
        { text: "customer.fullname", isHidden: true, width: '200px' },
        { text: "customer.phone", isHidden: true, wrapText: 'nowrap' },
        { text: "customer.gender", isHidden: true },
        { text: "customer.email", isHidden: true },
        { text: "user.is_active", isHidden: true },
        // { text: "customer.privilege", isHidden: true },
        { text: "apartment.name", isHidden: true }
      ],
      customColumns: {
        "user.is_active": {
          true: "btn-label label-success glyphicon glyphicon-ok",
          false: "btn-label label-danger glyphicon glyphicon-remove"
        }
      },
      columnsCustomer: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },
      actions: ["common.modify", "common.delete"],
      //hdBackground         : "background-color: #4b646f;color:white;border-bottom:2px solid #f4f4f4;", //00a65a
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;", //00a65a
      tblBorder: "border: 1px solid orange",
      originalRecordData: [],
      isModalVisible: false,
      json_data_cutomer: [],
      json_fields_customer: {
        UserID: "username",
        Password: "password",
        Họ: "last_name",
        Tên: "first_name",
        Email: "email",
        "Ngày Sinh": "profile.dob",
        "Điện Thoại": "profile.phone",
        "Giới Tính": "profile.gender",
        "CRM Code": "profile.customer_crm_code",
        "Quốc Gia": "profile.country_name"
      },
      checkSelect: {},
      Datas: {
        // We will make a Workbook contains 2 Worksheets
        customers: [
          { name: "cat", category: "animal" },
          { name: "dog", category: "animal" },
          { name: "pig", category: "animal" }
        ],
        pokemons: [
          { name: "pikachu", category: "pokemon" },
          { name: "Arbok", category: "pokemon" },
          { name: "Eevee", category: "pokemon" }
        ]
      },
      paginatorItem: {
        commit_function: "GET_CUSTOMER_LIST"
      },
      search: {
        code: "",
        username: "",
        searchText: "",
        phone: "",
        gender: "",
        email: "",
        privilege: "",
        country_name: "",
        apartment_code: null,
        isActive: null
      },
      isLoading: false,
      entryId: 0,
      customerTypeList: [
        { value: 0, text: 'project.all', total: 0 },
        { value: 1, text: 'customer.personal', total: 0 },
        { value: 2, text: 'customer.company', total: 0 },
        { value: 3, text: 'customer.owner', total: 0 },
        { value: 4, text: 'customer.member', total: 0 }
      ],
      customerTypeSelect: 0,
      exportExcelData: {
        wscols: []
      },
    };
  },
  watch: {
    GET_LANG: function() {
      this.getCustomerList(1)
    },
    GET_CUSTOMER_DATA: function() {
      this.gridCustomerDataList = [];
      this.GET_CUSTOMER_DATA.forEach((customer, i) => {
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let code = customer.code;
        let username = customer.username;
        let id = customer.id;
        let fullname = utils.getFullName(
          customer.firstname,
          customer.lastname,
          i18n.locale
        );
        let lastlogin = customer.lastlogin;
        let email = customer.email;
        let phone = utils.formatPhoneWithSpace(customer.phone, "");
        let gender = this.$t(this.getGender(customer.gender))
        let crmcode = customer.crmcode;
        let country_name = customer.country_name;
        let privilege =
          customer.privilege.length > 0
            ? customer.privilege[0].project_member_role_code
            : "";
        let data = {
          "common.nonumber": nonumber,
          "customer.customer_code": code,
          "customer.username": username,
          "customer.fullname": utils.capitalizeFirstInString(fullname),
          //'customer.firstname': firstname,
          //'customer.lastname':lastname,
          "customer.lastlogin": lastlogin,
          "customer.email": email,
          //"customer.age":age,
          "customer.phone": phone,
          "customer.gender": gender,
          "customer.crmcode": crmcode,
          "user.is_active": customer.profile.is_active,
          "customer.privilege": `${privilege}`,
          "customer.country": country_name,

          "customer.is_company": customer.is_company,
          "apartment.name": this.getApartmentNameList(customer.apartment),
          id: id
        };
        this.gridCustomerDataList.push(data);
      });
    },
    GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA: function() {
      if (!utils.isNull(this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data)) {
        const viewedColumnsKey = Object.keys(
          this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data.viewed_columns
        );
        const viewedColumns = this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data
          .viewed_columns;
        if (this.gridColumns.length == viewedColumns.length) {
          let newGridColumns = [];
          for (
            let j = 0, sizeOrigin = this.gridColumns.length;
            j < sizeOrigin;
            j++
          ) {
            for (let i = 0, size = viewedColumnsKey.length; i < size; i++) {
              if (this.gridColumns[j].text == viewedColumnsKey[i]) {
                let viewdColumnObject = {};
                viewdColumnObject.text = viewedColumnsKey[i];
                viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[i]];
                newGridColumns.push(viewdColumnObject);
                break;
              }
            }
          }
          this.gridColumns = newGridColumns;
          this.columnsCustomer.data_list = this.gridColumns;
          this.checkSelect = this.columnsCustomer.data_list;
        }
        // update when add columns in table
        else if (this.gridColumns.length != viewedColumnsKey.length) {
          let updateGridColumns = [];
          for (let i = 0; i < this.gridColumns.length; i++) {
            for (let j = 0; j < viewedColumnsKey.length; j++) {
              if (this.gridColumns[i] != viewedColumnsKey[j]) {
                let viewdColumnObject = {};
                viewdColumnObject.text = this.gridColumns[i].text;
                viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[j]];
                updateGridColumns.push(viewdColumnObject);
                break;
              }
            }
          }
          this.gridColumns = updateGridColumns;
          this.columnsCustomer.data_list = this.gridColumns;
          this.checkSelect = this.columnsCustomer.data_list;
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_CUSTOMER_DATA",
      "GET_LANG",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA",
      "GET_ACCOUNT_DATA"
    ])
  },

  methods: {
    getGender(gender) {
      return utils.getGender(gender)
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onColumnSelect: function(tables) {
      let tableDataObj = {};
      let tableDataObjChild = {};
      tableDataObjChild["tablename"] = "customerlist";
      tables.data_list.forEach(element => {
        tableDataObj[element.text] = element.isHidden;
      });
      tableDataObjChild["tablerow"] = tableDataObj;
      this.SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG(tableDataObjChild)
        .then(
          function() {
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    onSearchCustomer: async function() {
      await this.getNumberCustomerInType()
      this.getCustomerList(1)
    },
    getCustomerList: function(page) {
      const data = {
        params: {
          page: page,
          code: this.search.code,
          username: this.search.username,
          searchText: this.search.searchText,
          phone: this.search.phone,
          gender: this.search.gender,
          email: this.search.email,
          privilege: this.search.privilege,
          country_name: this.search.country_name,
          customer_type: this.customerTypeSelect,
          apartmentCode: this.search.apartment_code,
          isActive: this.search.isActive
        }
      };
      this.isLoading = true;
      this.GET_CUSTOMER_LIST(data).then(
        function() {
          this.isLoading = false;
        }.bind(this)
      )
      .catch(
        function() {
          this.isLoading=false
        }.bind(this)
      );
    },
    getGroupname(id) {
      if (id === 1) {
        return this.$t("customer.group_title[0].admin");
      } else if (id === 2) {
        return this.$t("customer.group_title[0].mod");
      } else if (id === 3) {
        return this.$t("customer.group_title[0].staff");
      } else if (id === 4) {
        return this.$t("customer.group_title[0].customer");
      } else {
        return this.$t("customer.group_title[0].operator");
      }
    },
    getPrivilegeMode(name) {
      let nameTrim = new String(name).trim();
      if (nameTrim == new String("Quản Trị").trim()) {
        return this.$t("user.privilege_mode[0]");
      } else if (nameTrim == new String("Quản Lý").trim()) {
        return this.$t("user.privilege_mode[1]");
      } else if (nameTrim == new String("Nhân Viên").trim()) {
        return this.$t("user.privilege_mode[2]");
      } else if (nameTrim == new String("Thông Thường").trim()) {
        return this.$t("user.privilege_mode[3]");
      } else if (nameTrim == new String("Quản Trị").trim()) {
        return this.$t("user.privilege_mode[4]");
      } else if (nameTrim == new String("Ban Quản Lý").trim()) {
        return this.$t("user.privilege_mode[5]");
      } else if (nameTrim == new String("Kĩ Thuật").trim()) {
        return this.$t("user.privilege_mode[6]");
      } else if (nameTrim == new String("Kế Toán").trim()) {
        return this.$t("user.privilege_mode[7]");
      } else if (nameTrim == new String("Lễ Tân").trim()) {
        return this.$t("user.privilege_mode[8]");
      }
      return "";
    },
    clickToSmallBox() {
      alert("click!!!: clickToSmallBox");
    },
    callback: function() {
      this.$router.push({
        name: "CustomerAdd",
        params: {
          id: 0
        },
        query: {
          is_company: false,
          callback: "Customer"
        }
      });
    },
    modal_addcustomer_to_project: function() {
      $("#modal-get-customer-to-project").modal("show");
    },
    onGetCustomerToProject: function() {
      let data = {
        email: this.general_email,
        expire_date: null
      };
      this.Add_CUSTOMER_TO_PROJECT(data)
        .then(
          function() {
            $("#modal-get-customer-to-project").modal("hide");
            const data = {
              params: {
                page: 1
              }
            };
            this.GET_CUSTOMER_LIST(data);
            this.columnsCustomer.data_list = this.gridColumns;
            const filter = {
              params: {
                tablename: "customerlist"
              }
            };
            this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function(error) {
            $("#modal-get-customer-to-project").modal("hide");
            let error_message = error.response.data.message;
            if (error_message === "user_existed") {
              this.ON_SHOW_TOAST({
                message: this.$t("customer.error_messages.email_exist_project"),
                styleType: "danger"
              });
            } else if (error_message === "cannot_find_user") {
              this.ON_SHOW_TOAST({
                message: this.$t("customer.error_messages.cannot_find_email"),
                styleType: "danger"
              });
            } else if (error_message === "cannot_find_customer") {
              this.ON_SHOW_TOAST({
                message: this.$t(
                  "customer.error_messages.cannot_find_email_customer"
                ),
                styleType: "danger"
              });
            } else {
              this.ERROR_TOAST();
            }
          }.bind(this)
        );
    },
    remove_user: function(id) {
      this.isLoading = true
      this.DELETE_CUSTOMER({ id: id })
        .then(
          function() {
            $("#modal-confirm-customer-out-of-project").modal("hide");
            const data = {
              params: {
                page: 1
              }
            };
            this.GET_CUSTOMER_LIST(data);
            this.columnsCustomer.data_list = this.gridColumns;
            const filter = {
              params: {
                tablename: "customerlist"
              }
            };
            this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);
            this.SUCCESS_TOAST();
            this.isLoading = false
          }.bind(this)
        )
        .catch(
          function() {
            $("#modal-confirm-customer-out-of-project").modal("hide");
            this.ERROR_TOAST();
            this.isLoading = false
          }.bind(this)
        );
    },
    onExport: async function() {
      try {
        const data = {
          params: {
            code: this.search.code,
            username: this.search.username,
            searchText: this.search.searchText,
            phone: this.search.phone,
            gender: this.search.gender,
            email: this.search.email,
            privilege: this.search.privilege,
            country_name: this.search.country_name,
            customer_type: this.customerTypeSelect,
            apartmentCode: this.search.apartment_code,
            isActive: this.search.isActive

          }
        };
        this.isLoading = true
        this.json_data_cutomer = [];
        await this.GET_CUSTOMER_LIST(data).then(
          function(res) {
            let result = res.data;
            result.forEach((v, index) => {
              let json_data = {
                STT: index + 1,
                "Mã Khách Hàng": v.profile.code,
                Email: v.email,
                "Họ Và Tên": v.last_name + " " + v.first_name,
                "Địa chỉ": v.profile.address,
                "Điện Thoại": utils.formatPhoneWithSpace(v.profile.phone, ""),
                "Giới Tính": this.$t(this.getGender(v.profile.gender)),
                "Năm sinh": utils.formatSqlDate(v.profile.dob,  null, "DD/MM/YYYY"),
                "Quốc tịch": v.profile.country_name,
                "CMND/CCCD": v.profile.identificationnumber,
                "Passport": v.profile.passport,
                "Tên Căn Hộ": this.getApartmentNameList(v.apartments)
              };
              // for (let i = 0; i < this.checkSelect.length; i++) {
              //   if (
              //     this.checkSelect[i].isHidden == false &&
              //     this.checkSelect[i].text == "common.nonumber"
              //   )
              //     delete json_data.STT;
              //   else if (
              //     this.checkSelect[i].isHidden == false &&
              //     this.checkSelect[i].text == "customer.customer_code"
              //   )
              //     delete json_data["Mã Khách Hàng"];
              //   else if (
              //     this.checkSelect[i].isHidden == false &&
              //     this.checkSelect[i].text == "customer.fullname"
              //   )
              //     delete json_data["Họ Và Tên"];
              //   else if (
              //     this.checkSelect[i].isHidden == false &&
              //     this.checkSelect[i].text == "customer.phone"
              //   )
              //     delete json_data["Điện Thoại"];
              //   else if (
              //     this.checkSelect[i].isHidden == false &&
              //     this.checkSelect[i].text == "customer.gender"
              //   )
              //     delete json_data["Giới Tính"];
              //   else if (
              //     this.checkSelect[i].isHidden == false &&
              //     this.checkSelect[i].text == "customer.email"
              //   )
              //     delete json_data["Email"];
              //   else if (
              //     this.checkSelect[i].isHidden == false &&
              //     this.checkSelect[i].text == "customer.privilege"
              //   )
              //     delete json_data["Phân Quyền"];
              //   else if (
              //     this.checkSelect[i].isHidden == false &&
              //     this.checkSelect[i].text == "customer.country"
              //   )
              //     delete json_data["Quốc Gia"];
              //   else if (
              //     this.checkSelect[i].isHidden == false &&
              //     this.checkSelect[i].text == "user.is_active"
              //   )
              //     delete json_data["Tình Trạng"];
              // }
              this.getWscols(json_data)
              this.json_data_cutomer.push(json_data);
            });
            this.isLoading = false
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false
          }.bind(this)
        );
      } catch (error) {
        /*
         * 'error' is corresponding with 'xhr.statusText'
         * from either 'https://something.com' or 'https://other.com'
         */
      }

      // export json to Worksheet of Excel
      // only array possible
      var customers = XLSX.utils.json_to_sheet(this.json_data_cutomer);
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, customers, "Customers"); // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')

      // var wscols = [
      //   { wch: 15 }, // STT
      //   { wch: 15 }, // Mã Khách Hàng
      //   { wch: 40 }, // Họ và Tên
      //   { wch: 15 }, // SDT
      //   { wch: 15 }, // Giới tính
      //   { wch: 35 }, // Email
      //   { wch: 30 }, // Phân Quyền
      //   { wch: 30 } // Quốc Gia
      // ];
      customers["!cols"] = this.exportExcelData.wscols;

      // export Excel file
      XLSX.writeFile(wb, "Customers.xlsx"); // name of the file is 'book.xlsx'
    },
    getWscols: function(obj) {
      let wscolsLength = this.exportExcelData.wscols.length
      let cellWidthDefault = 10
      if (wscolsLength === 0) {
        let objKeys = Object.keys(obj)
        objKeys.forEach(k=> {
          let cellWidth = utils.isEmptyString(obj[k]) 
            ? cellWidthDefault 
            : obj[k].toString().length > cellWidthDefault ? obj[k].toString().length : cellWidthDefault
          this.exportExcelData.wscols.push(
            {wch: cellWidth})
        })
      } else {
        let objKeys = Object.keys(obj)
        objKeys.forEach((k, i)=> {
          if (!utils.isEmptyString(obj[k]) && obj[k].toString().length > this.exportExcelData.wscols[i].wch) {
            this.exportExcelData.wscols[i].wch = obj[k].toString().length
          }
        })
      }
    },
    importExcel: function() {
      this.$router.push({
        name: "CustomerImportExcel",
        params: {
          id: 0
        }
      });
    },
    crudActions: function(recordData, actionsType, isModalVisible) {
      if (actionsType == LTEActionTypeEnum.MODIFY) {
        this.$router.push({
          name: "CustomerAdd",
          params: {
            id: recordData.id
          },
          query: {
            is_company: recordData["customer.is_company"],
            callback: "Customer"
          }
        });
      } else if (actionsType == LTEActionTypeEnum.DELETED) {
        this.user_deleted_id = recordData.id;
        this.user_deleted_email = recordData["customer.email"];
        $("#modal-confirm-customer-out-of-project").modal("show");
      } else {
        this.originalRecordData = recordData;
        this.isModalVisible = isModalVisible;
      }
    },
    // https://completejavascript.com/xu-ly-bat-dong-bo-callback-promise-async-await/
    async startDownload() {
      try {
        await this.GET_CUSTOMER_LIST().then(
          function(res) {
            let result = res.data;
            result.results.forEach(v => {
              this.json_data_cutomer.push(v);
            });
          }.bind(this)
        );
      } catch (error) {
        /*
         * 'error' is corresponding with 'xhr.statusText'
         * from either 'https://something.com' or 'https://other.com'
         */
      }
    },
    finishDownload() {
      //console.log("finishDownload");
    },
    onPrevPagination: function() {
      const data = {
        url: this.PAGE_ARROW.prev,
        commit_funtion: "GET_CUSTOMER_LIST"
      };
      this.PAGINATION_PREV_PAGE(data);
    },
    onNextPagination: function() {
      const data = {
        url: this.PAGE_ARROW.next,
        commit_funtion: "GET_CUSTOMER_LIST"
      };
      this.PAGINATION_NEXT_PAGE(data);
    },
    onPagination: function(data) {
      let page = data.params.page
      this.getCustomerList(page)
    },
    onClickItemRow: function(entryId) {
      this.entryId = entryId;
      $("#modal-information-user").modal("show");
    },
    onChangeCustomerType: function(data) {
      this.customerTypeSelect = data.value
      this.onSearchCustomer()
    },
    getNumberCustomerInType: function() {
      const data = {
        params: {
          code: this.search.code,
          username: this.search.username,
          searchText: this.search.searchText,
          phone: this.search.phone,
          gender: this.search.gender,
          email: this.search.email,
          privilege: this.search.privilege,
          country_name: this.search.country_name,
          apartmentCode: this.search.apartment_code,
          isActive: this.search.isActive
          // customer_type: this.customerTypeSelect
        }
      };
      this.GET_CUSTOMER_TYPE_LIST(data)
        .then(
          function(res) {
            let data = res.data
            data.forEach((value, index) => {
              this.customerTypeList[index].total = value
            })
          }.bind(this)
        )
    },
    getApartmentNameList: function(apartmentList) {
      let result = ''
      apartmentList.forEach((e, i)=> {
        result += i < apartmentList.length -1 ? `${e.apartment_code}, ` : e.apartment_code
      })
      return result
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "Add_CUSTOMER_TO_PROJECT",
      // "REMOVE_USER_OUT_PROJECT",
      "GET_CUSTOMER_LIST",
      "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_CUSTOMER_TYPE_LIST",
      "DELETE_CUSTOMER"
    ])
  },
  mounted() {
    this.getCustomerList(1)
    this.columnsCustomer.data_list = this.gridColumns;
    const filter = {
      params: {
        tablename: "customerlist"
      }
    };
    this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);
    this.getNumberCustomerInType()
  },

  components: {
    "lte-button": LTEButton,
    "lte-table": LTETable,
    "lte-core-alert": LTECoreAlert,
    // downloadExcel: JsonExcel,
    paginator: Paginator,
    loading: Loading,
    "information-modal": InformationModal,
    "select-option-check": SelectOptionCheck
  }
};
</script>
<style scoped>
.dropdown-trigger {
  min-width: 4em;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
}
.customer-type-class{
  padding: 5px 15px;
  cursor: pointer;
}
.border-right{
  border-right: 1px solid #000000;
}
.customer-type-select {
  font-weight: bold;
  color: #006ad4;
}
</style>



// WEBPACK FOOTER //
// src/views/Customer/CustomerList.vue